var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    width: 1200,
    height: 600,
    preserveAspectRatio: "xMidYMid slice",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1200,0 L1200,700 L0,700z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1200,0 L1200,700 L0,700z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_48)",
    style: {
      display: "block"
    },
    transform: "matrix(1,0,0,1,0,-50)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951056718826294,0.30901646614074707,-0.30901646614074707,0.951056718826294,744.343994140625,358.8800048828125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-135.88800048828125,11.630000114440918 C-135.88800048828125,11.630000114440918 161.21600341796875,11.630000114440918 161.21600341796875,11.630000114440918"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951056718826294,0.30901646614074707,-0.30901646614074707,0.951056718826294,715.844970703125,278.989013671875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-51.51100158691406,11.194000244140625 C-51.51100158691406,11.194000244140625 76.77200317382812,11.194000244140625 76.77200317382812,11.194000244140625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951056718826294,0.30901646614074707,-0.30901646614074707,0.951056718826294,674.6339721679688,237.17799377441406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-8.550999641418457,11.479999542236328 C-8.550999641418457,11.479999542236328 32.71200180053711,11.479999542236328 32.71200180053711,11.479999542236328"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,655.7789916992188,354.52099609375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-149.2050018310547,11.59000015258789 C-149.2050018310547,11.59000015258789 149.76400756835938,11.59000015258789 149.76400756835938,11.59000015258789"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,628.4710083007812,430.4129943847656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-68.625,12.008999824523926 C-68.625,12.008999824523926 63.58300018310547,12.008999824523926 63.58300018310547,12.008999824523926"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,587.3599853515625,469.5539855957031)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13.000007708670736,
    d: " M-27.27400016784668,12.432000160217285 C-27.27400016784668,12.432000160217285 21.121999740600586,12.432000160217285 21.121999740600586,12.432000160217285"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951056718826294,0.30901646614074707,-0.30901646614074707,0.951056718826294,555.280029296875,358.62200927734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-134.9949951171875,11.593999862670898 C-134.9949951171875,11.593999862670898 161.53700256347656,11.593999862670898 161.53700256347656,11.593999862670898"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,537.1329956054688,232.6959991455078)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13.000007708670736,
    d: " M-20.481000900268555,11.848999977111816 C-20.481000900268555,11.848999977111816 21.614999771118164,11.848999977111816 21.614999771118164,11.848999977111816"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,495.9309997558594,272.9540100097656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-61.869998931884766,10.366000175476074 C-61.869998931884766,10.366000175476074 64.48699951171875,10.366000175476074 64.48699951171875,10.366000175476074"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510566592216492,-0.309016615152359,0.309016615152359,0.9510566592216492,466.4570007324219,354.5249938964844)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-147.19900512695312,10.696999549865723 C-147.19900512695312,10.696999549865723 148.572998046875,10.696999549865723 148.572998046875,10.696999549865723"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_4)",
    transform: "matrix(1,0,0,1,0,-50)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,0.30901700258255005,-0.30901700258255005,0.9510565400123596,744.343994140625,358.8800048828125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-135.88800048828125,11.630000114440918 C-135.88800048828125,11.630000114440918 161.21600341796875,11.630000114440918 161.21600341796875,11.630000114440918"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,0.30901700258255005,-0.30901700258255005,0.9510565400123596,715.844970703125,278.989013671875)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-51.51100158691406,11.194000244140625 C-51.51100158691406,11.194000244140625 76.77200317382812,11.194000244140625 76.77200317382812,11.194000244140625"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,0.30901700258255005,-0.30901700258255005,0.9510565400123596,674.6339721679688,237.17799377441406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-8.550999641418457,11.479999542236328 C-8.550999641418457,11.479999542236328 32.71200180053711,11.479999542236328 32.71200180053711,11.479999542236328"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,655.7789916992188,354.52099609375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-149.2050018310547,11.59000015258789 C-149.2050018310547,11.59000015258789 149.76400756835938,11.59000015258789 149.76400756835938,11.59000015258789"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,628.4710083007812,430.4129943847656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-68.625,12.008999824523926 C-68.625,12.008999824523926 63.58300018310547,12.008999824523926 63.58300018310547,12.008999824523926"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,587.3599853515625,469.5539855957031)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-27.27400016784668,12.432000160217285 C-27.27400016784668,12.432000160217285 21.121999740600586,12.432000160217285 21.121999740600586,12.432000160217285"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,0.30901700258255005,-0.30901700258255005,0.9510565400123596,555.280029296875,358.62200927734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-134.9949951171875,11.593999862670898 C-134.9949951171875,11.593999862670898 161.53700256347656,11.593999862670898 161.53700256347656,11.593999862670898"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,537.1329956054688,232.6959991455078)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-20.481000900268555,11.848999977111816 C-20.481000900268555,11.848999977111816 21.614999771118164,11.848999977111816 21.614999771118164,11.848999977111816"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,495.9309997558594,272.9540100097656)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-61.869998931884766,10.366000175476074 C-61.869998931884766,10.366000175476074 64.48699951171875,10.366000175476074 64.48699951171875,10.366000175476074"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9510565400123596,-0.30901700258255005,0.30901700258255005,0.9510565400123596,466.4570007324219,354.5249938964844)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 13,
    d: " M-147.19900512695312,10.696999549865723 C-147.19900512695312,10.696999549865723 148.572998046875,10.696999549865723 148.572998046875,10.696999549865723"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.79ebfa753dec1713bbc9789ac307ff9a.svg";
export { ForwardRef as ReactComponent };